﻿export class response_details_amount {
    public currency: string | null = null;
    public fee: string | null = null;
    public total: string | null = null;
}